/// Ce que portait le lien d'arrivée, gardé jusqu'à l'inscription : elle peut
/// venir plus tard, par mot de passe ou par Google. Le code d'affiliation
/// (`?ref=`) dit le parrain, la provenance dit la publicité ou la campagne.
const KEY: StoreKeys = 'referral_code';
const ORIGIN_KEY: StoreKeys = 'signup_origin';
const CODE = /^[A-Za-z0-9-]{3,32}$/;

export function captureReferralCode(): void {
  const ref = new URLSearchParams(window.location.search).get('ref')?.trim();
  if (ref && CODE.test(ref)) window.store.set(KEY, ref);
}

export function referralCode(): string | undefined {
  return window.store.get(KEY) ?? undefined;
}

/// Provenance d'un inscrit, telle que le serveur l'attend.
export type Acquisition = {
  acquisitionSource?: string;
  acquisitionMedium?: string;
  acquisitionCampaign?: string;
  acquisitionLanding?: string;
};

/// Un lien qui se dit payant, avec les mots d'usage (cpc, ppc, paid_social…).
/// Même règle que le serveur et que le site.
const PAID = /^(.*cp.*|ppc|retargeting|paid.*|ads?)$/;

/// Ce que l'adresse d'ouverture dit de la provenance. Le site y recopie ce
/// qu'il a observé à l'arrivée du visiteur (`utm_source`, `utm_medium`,
/// `utm_campaign`, et `kara_landing` pour la page d'arrivée). Une publicité X y
/// ajoute `twclid` : l'arrivée est alors payée, quoi que dise le lien.
///
/// Ce qu'on garde suit la règle du site : un lien de campagne (publicité,
/// `utm_campaign`) remplace ce qui est noté ; sinon la première origine connue
/// reste, et une page d'arrivée seule n'est notée que si rien ne l'est.
export function captureAcquisition(): void {
  const params = new URLSearchParams(window.location.search);
  const read = (name: string, size: number) =>
    params.get(name)?.trim().slice(0, size) || undefined;
  const ad = params.has('twclid');
  const origin: Acquisition = {
    acquisitionSource: read('utm_source', 64) ?? (ad ? 'x' : undefined),
    acquisitionMedium: ad ? 'paid' : read('utm_medium', 32),
    acquisitionCampaign: read('utm_campaign', 128),
    acquisitionLanding: read('kara_landing', 128),
  };
  const campaign =
    !!origin.acquisitionCampaign ||
    PAID.test(origin.acquisitionMedium?.toLowerCase() ?? '');
  if (!campaign) {
    const known = acquisition();
    if (known.acquisitionSource || known.acquisitionCampaign) return;
    if (
      !origin.acquisitionSource &&
      (Object.keys(known).length > 0 || !origin.acquisitionLanding)
    ) {
      return;
    }
  }
  window.store.set(ORIGIN_KEY, JSON.stringify(origin));
}

export function acquisition(): Acquisition {
  try {
    const stored = JSON.parse(window.store.get(ORIGIN_KEY) ?? '{}');
    return stored && typeof stored === 'object' ? stored : {};
  } catch {
    return {};
  }
}

/// Le lien a servi : l'inscription suivante sur cet appareil n'en hérite pas.
export function clearArrival(): void {
  window.store.set(KEY, null);
  window.store.set(ORIGIN_KEY, null);
}

/// Lien d'inscription qui rattache le nouvel inscrit au porteur du code.
export function referralLink(code: string): string {
  return `${import.meta.env.VITE_WEBSITE_REDIRECT_URI}/sign-up?ref=${code}`;
}
